import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {_copyObj} from "../ccl-util";

@Component({
    selector: 'ccl-paging',
    templateUrl: './paging.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./paging.component.less']
})
export class PagingComponent implements OnInit {
    // å½å¤äºå è½½ç¶ææ¶ï¼å¼ä¸ºtrueï¼å°ææ¶ç¦æ­¢æä½
    loading = false;
    currentPage = 1; // å½åå±ç¤ºæ°æ®çé¡µæ°
    total = 0; // æ»æ¡æ°
    result = []; // å½åé¡µçæ°æ®
    params: any; // è¯·æ±åæ°

    // è¯·æ±ç±»å GET or POST
    @Input()
    method: 'GET' | 'POST' | 'get' | 'post' = 'POST';// GET or POST

    // è¯·æ±å°å
    @Input()
    private url = '';

    // æ¯é¡µæ¾ç¤ºå¤å°æ¡æ°æ®
    @Input()
    pageSize = 10;

    // è®¾ç½®æ°æ®è·åkey
    @Input()
    private rowsKey = 'rows';

    // è®¾ç½®æ»æ°è·åkey
    @Input()
    private totalKey = 'totalcount';

    // ç¦ç¨
    @Input()
    disabled = false;

    // è¥è®¾ç½®æ­¤åæ°ï¼åç»ä»¶åå¤å°±ç»ªåèªå¨è§¦åæ¥è¯¢
    @Input()
    autoQueryParam: any;

    // æ¯å¦æ¾ç¤ºè·³è½¬é¡µæ°ç»ä»¶
    @Input()
    paginationShowPageGo = false;

    // è¯·æ±åéåè§¦åï¼ææºä¼ä¿®æ¹è¯·æ±åæ°
    @Input()
    private beforeRequest: (data, url) => any;

    // è¯·æ±å®æåè§¦åï¼ææºä¼é¢å¤çååºæ°æ®
    @Input()
    private beforeResponse: (data, url) => any;

    constructor(private http: HttpClient, private cdr: ChangeDetectorRef) {
    }

    ngOnInit() {
        if (this.autoQueryParam) {
            return this.queryList(this.autoQueryParam);
        }
    }

    // è§¦åæ¥è¯¢
    async queryList(params: any, page?: number, total ?: number) {
        if (this.disabled || this.loading) {
            return;
        }

        params = paramWrap(params, this.pageSize, page || 1, total) || {};

        if (this.beforeRequest) {
            params = this.beforeRequest(params, this.url) || params;
        }
        this.params = params; // cache params
        this.loading = true;
        let requestPromise;
        if (/get/i.test(this.method)) {
            requestPromise = this.http.get(this.url, {params: params}).toPromise();
        } else {
            requestPromise = this.http.post(this.url, params).toPromise();
        }
        try {
            let result: any = await requestPromise;

            if (+result.code !== 0) {
                throw result.msg || `åé¡µç»ä»¶è¯·æ±åçéè¯¯:${this.url}`;
            }

            result = result.data;
            if (this.beforeResponse) {
                result = this.beforeResponse(result, this.url) || result;
            }

            const rows = result[this.rowsKey];
            const total = parseInt(result[this.totalKey]);

            this.result = rows;
            this.total = total;
            this.currentPage = params.pageindex;

        } catch (e) {
            console.error(e);
        } finally {
            this.loading = false;
            this.cdr.markForCheck();
        }
    }

    // éæ°è§¦åæ¥è¯¢(ä½¿ç¨å½åçåæ°ï¼æ¥è¯¢å½åé¡µé¢)
    refresh() {
        if (this.disabled) {
            return;
        }
        return this.queryList(this.params, this.currentPage);
    }

    // éç½®æ¯é¡µæ¾ç¤ºçæ°éï¼å¹¶ä¸è§¦åæ¥è¯¢
    changePageSize(size: number) {
        this.pageSize = size;
        this.queryList(this.params);
    }
}

function paramWrap(params, pageSize, pageIndex, total?) {
    params = _copyObj(params);// clone

    params.pagesize = params.pageSize = params.currentPageSize = params.currentpagesize = pageSize;
    params.pageNum = params.currPage = params.pageindex = params.pageIndex = params.currentPageIndex = params.currentpageindex = pageIndex || 1;
    if (total) {
        params.pageTotal = total;
    }
    params = ignoreEmptyValue(params);
    return params;
}

function ignoreEmptyValue(params) {
    var data = {};
    Object.keys(params).forEach(key => {
        const value = params[key];
        if (value !== '' && value !== undefined && value !== null) {
            data[key] = value;
        }
    });
    return data;
}


